// Modificada por IAL | 2026-04-10 | Powered by ianossolutions.ai
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-notification-send-modal',
  templateUrl: './notification-send-modal.component.html',
  styleUrls: ['./notification-send-modal.component.scss']
})
export class NotificationSendModalComponent implements OnInit {
  templateNotification: any[] = [];
  selectAll = false;
  selectTemplate: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private firestore: FirestoreService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getNotificationTemplate();
  }

  getNotificationTemplate(): void {
    this.firestore.getAll("NotificationsPushTemplates").subscribe((res) => {
      const not = res.filter(r => r.active === true);
      not.forEach(n => {
        this.templateNotification.push({
          ...n,
          selected: false
        });
      });

    });
  }

  toggleSelection(uid: string): void {
    this.templateNotification = this.templateNotification.map(item => {
      if (item.uid === uid) {
        return { ...item, selected: !item.selected };
      }
      return { ...item, selected: false };
    });

    this.cdr.detectChanges();
  }

  toggleSelectAll() {
    if (this.selectAll) {
      this.templateNotification.forEach(template => {
        template.selected = false;
      });
      this.selectAll = false;
    } else {
      if (this.templateNotification.length > 0) {
        this.templateNotification[0].selected = true;
      }
      this.selectAll = true;
    }
  }

  hasSelectedTemplates(): boolean {
    return this.templateNotification.some(template => template.selected);
  }

  getSelectedCount(): number {
    return this.templateNotification.filter(t => t.selected).length;
  }

  sendNotifications() {
    const selectedTemplates = this.templateNotification.filter(template => template.selected);
    this.activeModal.close(selectedTemplates);
    // Aquí puedes llamar a tu servicio para enviar las notificaciones
  }

}
